export default __webpack_public_path__ + "static/media/lib-6.8cae3ecb.webp";